<template>
  <div class="activities">
    <Header 
      :img-url="require('@/assets/img/group.jpg')"
      class="activities__header"
      flex
    >
      <div>
        <h1 class="activities__headline">Actividades</h1>
        <a
          href="/docs/Revista FZB 2021.pdf"
          download="Revista FZB 2021.pdf"
          class="activities__primary-btn primary-btn animated fadeIn delay-0.5s"
        >
          Descargar <span>Revista FZB 2021</span>
        </a>

        <a
          href="/docs/Revista ser futuro --2022.pdf"
          download="Revista ser futuro --2022.pdf"
          class="activities__primary-btn primary-btn animated fadeIn delay-0.5s"
        >
          Descargar <span>Revista FZB 2022</span>
        </a>
      </div>

      <div>
        <h1 class="activities__headline">Proyectos</h1>
        <a 
          class="activities__primary-btn primary-btn"
          @click.stop="projectDialogVisibility = true"  
        >
          Nuevos Proyectos
        </a>
      </div>
    </Header>

    <AppModal 
      :is-visible="projectDialogVisibility"
      @close="projectDialogVisibility = false"
      headline="Proyectos"
    >
      <div>
        <p>SHI'RRAIN WAYUU</p>
        <router-link 
          class="activities__project-btn" 
          title="Ver más" 
          :to="{ 
            name: 'Projects', 
            params: { 
              name: `SHI'RRAIN WAYUU` 
            }, 
            query: { 
              count: 12 
            } 
          }"
        >
          <img :src="require('@/assets/img/projects/logo.png')" alt="Project logo" />

          <p>
            Ver más
          </p>
        </router-link>
      </div>
    </AppModal>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import AppModal from "@/components/common/AppModal.vue";

export default {
  name: "Activities",

  components: {
    Header,
    AppModal
  },

  data: () => ({
    projectDialogVisibility: false
  }),

  title() {
    return "Actividades";
  }
};
</script>

<style lang="scss" scoped>
.activities {
  $root: &;

  &__primary-btn {
    width: 100%;
  }

  &__headline {
    &::after {
      content: none;
    }
  }

  &__project-btn {
    width: 100%;
    height: 60px;
    margin: 10px auto 0;
    border-radius: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    cursor: pointer;
    color: #222;
    padding: 10px 2rem;
    box-shadow: 0px 7px 16px -7px rgba(#000, .3);
    transition: background-color .25s ease;
    background-color: rgba(#289ea8, .1);

    img {
      width: 60px;
      height: 60px;
      display: block;
      object-fit: contain;
    }

    p {
      font-size: .9rem;
      text-transform: uppercase;
      display: flex;
      align-items: center;

      &::after {
        opacity: 0;
        content: "\f054";
        font-weight: 900;
        visibility: hidden;
        transition: 0.3s all;
        font-family: "Font Awesome 5 Free";
      }
    }
    
    &:hover {
      @media (min-width: 1024px) {
        background-color: rgba(#289ea8, .15);
        
        p {
          &::after {
            opacity: 1;
            content: "\f054";
            font-weight: 900;
            margin-left: 1rem;
            visibility: visible;
            font-family: "Font Awesome 5 Free";
          }
        }
      }
    }
  }
}
</style>
